"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _HeroSearch = _interopRequireDefault(require("../partials-hero-search/HeroSearch"));
var _TextAnimation = _interopRequireDefault(require("../partials-text-animation/TextAnimation"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var HeroCarousel = /*#__PURE__*/function (_Component) {
  _inherits(HeroCarousel, _Component);
  function HeroCarousel(props) {
    var _this;
    _classCallCheck(this, HeroCarousel);
    _this = _callSuper(this, HeroCarousel, [props]);
    _this.transitionTimeout = 4000;
    _this.textLeaveTimeout = 1000;
    _this.state = {
      itemNumber: 0,
      activityNumber: 0,
      previousActivityNumber: 0,
      showImage: false
    };
    _this.updateImage = _this.updateImage.bind(_assertThisInitialized(_this));
    _this.updateActivity = _this.updateActivity.bind(_assertThisInitialized(_this));
    _this.startActivityUpdate = _this.startActivityUpdate.bind(_assertThisInitialized(_this));
    _this.incrementItemNumber = _this.incrementItemNumber.bind(_assertThisInitialized(_this));
    _this.showImage = _this.showImage.bind(_assertThisInitialized(_this));
    _this.createImageUrl = _this.createImageUrl.bind(_assertThisInitialized(_this));
    _this.getLocalizedTitle = _this.getLocalizedTitle.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(HeroCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ('undefined' !== typeof window) {
        setInterval(this.updateImage, this.transitionTimeout);
        setTimeout(this.startActivityUpdate, this.transitionTimeout - this.textLeaveTimeout);
        this.showImage();
      }
    }
  }, {
    key: "showImage",
    value: function showImage() {
      this.setState({
        showImage: true
      });
    }
  }, {
    key: "createImageUrl",
    value: function createImageUrl(itemNumber) {
      var cloudinaryId = (0, _lodash.get)(this.props, "heroData.items[".concat(itemNumber, "].contentCloudinaryId"));
      return "//img.peerspace.com/image/upload/f_auto,q_auto,dpr_auto,fl_progressive/".concat(cloudinaryId);
    }
  }, {
    key: "incrementItemNumber",
    value: function incrementItemNumber(itemNumber) {
      return (itemNumber + 1) % (0, _lodash.get)(this.props, 'heroData.items.length', 0);
    }
  }, {
    key: "updateImage",
    value: function updateImage() {
      var _this2 = this;
      this.setState(function (state) {
        return {
          itemNumber: _this2.incrementItemNumber(state.itemNumber)
        };
      });
    }
  }, {
    key: "startActivityUpdate",
    value: function startActivityUpdate() {
      this.updateActivity();
      setInterval(this.updateActivity, this.transitionTimeout);
    }
  }, {
    key: "updateActivity",
    value: function updateActivity() {
      var _this3 = this;
      this.setState(function (state) {
        return {
          activityNumber: _this3.incrementItemNumber(state.itemNumber),
          previousActivityNumber: state.activityNumber
        };
      });
    }
  }, {
    key: "getLocalizedTitle",
    value: function getLocalizedTitle() {
      var activityGender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'n';
      return this.props.intl.formatMessage({
        id: 'hero_carousel.hero_carousel.text_animation_your_next',
        defaultMessage: '{gender,select,f{Your next}m{Your next}n{Your next}other{Your next}}'
      }, {
        gender: activityGender
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        itemNumber = _this$state.itemNumber,
        activityNumber = _this$state.activityNumber,
        previousActivityNumber = _this$state.previousActivityNumber,
        showImage = _this$state.showImage;
      var showCovidLink = this.props.showCovidLink;
      var image = this.createImageUrl(itemNumber);
      var nextItemNumber = this.incrementItemNumber(itemNumber);
      var nextImage = this.createImageUrl(nextItemNumber);
      var style = {
        backgroundImage: "url(".concat(image, ")")
      };
      var headerActivity = (0, _lodash.get)(this.props, "heroData.items[".concat(activityNumber, "].contentTitle"), 'meeting');
      var imageDetails = (0, _lodash.get)(this.props, "heroData.items[".concat(itemNumber, "]"), {});
      var activityGender = (0, _lodash.get)(this.props, "heroData.items[".concat(activityNumber, "].activityGender"), 'n');
      var prevActivityGender = (0, _lodash.get)(this.props, "heroData.items[".concat(previousActivityNumber, "].activityGender"), 'n');
      // This value allows us to avoid the text animation for the static labels
      // e.g. For en-US locale the text is static and doesn't depend on activity gender, it's always 'Your next'
      // in this case enter timeout will false, otherwise it's default 1000 ms
      var enterTimeout = this.getLocalizedTitle(activityGender) === this.getLocalizedTitle(prevActivityGender) ? false : 1000;
      var imageDetailsDescription = imageDetails.contentSubtitle1;
      var imageDetailsLocation = imageDetails.contentSubtitle2;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "HeroCarousel flex column space-between"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container hero-search-container flex column center ".concat(showCovidLink ? 'no-covid-link-container' : '')
      }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement(_TextAnimation.default, {
        text: this.getLocalizedTitle(activityGender),
        enterTimeout: enterTimeout
      }), "\xA0", /*#__PURE__*/_react.default.createElement(_TextAnimation.default, {
        text: headerActivity
      }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "hero_carousel.hero_carousel.text_animation_starts_here",
        defaultMessage: "starts here"
      })), showCovidLink && /*#__PURE__*/_react.default.createElement("div", {
        className: "covid-health-safety-link row margin-sm-bottom"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "col-xs-1"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "hidden-xs",
        src: "/web-templates/assets/images/spray-bottle-white.svg?v=rb"
      }), /*#__PURE__*/_react.default.createElement("img", {
        className: "hidden-sm hidden-md hidden-lg hidden-xl",
        src: "/web-templates/assets/images/spray-bottle-gray.svg?v=rb"
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "col-xs-11 gutter-left-xs"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "hero_carousel.hero_carousel.learn_about",
        defaultMessage: "Learn about our {link}",
        values: {
          link: /*#__PURE__*/_react.default.createElement("a", {
            href: "https://book.peerspace.com/covid-19/overview",
            target: "_blank",
            rel: "noopener noreferrer",
            className: "heavy"
          }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "hero_carousel.hero_carousel.covid_link",
            defaultMessage: "COVID-19 Health & Safety Measures "
          }), /*#__PURE__*/_react.default.createElement("i", {
            className: "ico ico-sm icon-arrow-nav"
          }))
        }
      }))), /*#__PURE__*/_react.default.createElement(_HeroSearch.default, {
        searchFormProps: this.props.searchFormProps
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "text-small flex end bottom hidden-xs"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "imageDetails column"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "heavy"
      }, imageDetailsDescription), /*#__PURE__*/_react.default.createElement("div", null, imageDetailsLocation))), /*#__PURE__*/_react.default.createElement("div", {
        className: "img-container",
        style: style
      }), showImage && /*#__PURE__*/_react.default.createElement("img", {
        src: nextImage,
        alt: "peerspace",
        className: "hide"
      }));
    }
  }]);
  return HeroCarousel;
}(_react.Component);
HeroCarousel.propTypes = {
  heroData: _propTypes.default.object,
  searchFormProps: _propTypes.default.object,
  showCovidLink: _propTypes.default.bool,
  intl: _reactIntl.intlShape
};
var _default = exports.default = (0, _reactIntl.injectIntl)(HeroCarousel);